declare var Highcharts: any;
import { Injectable } from '@angular/core';
import { ApiService } from '../../services/api.service';
@Injectable()
export class DashboardService {

  constructor(private apiService: ApiService) {
    this.apiService = apiService;
  }

  getLastUpdated() {
    return this.apiService.getEiaUrl('last_updated', {});
  }

  getNuclearOutages() {
    return this.apiService.getEiaUrl('nuclear_outages', {});
  }

  getTemperatureData(){
    return this.apiService.getEiaUrl('temperatures_us_daily_average', {});
  }

  getChartData() {
    return this.apiService.getEiaUrl('', {});
  }

  getHeatMapData(){
    return this.apiService.getEiaUrl('temperatures_departure_from_normal', {});
  }

  getGasConsumptionElectricPower(consumptionSource){
    return this.apiService.getEiaUrl('gas_consumption', {'source' : consumptionSource});
  }

  getStorageWeeklyWorking(storageSource){
    return this.apiService.getEiaUrl('gas_storage_weekly_working', {'region' : storageSource});
  }

  getLatestInventory() {
    return this.apiService.getEiaUrl('latest_inventory', {});
  }

  getStorageWeeklyNetChange(netChangeStorage){
    return this.apiService.getEiaUrl('gas_storage_weekly_net_change', {'region' : netChangeStorage});
  }

  getGasTradeDisposition(){
    return this.apiService.getEiaUrl('gas_trade_disposition',{});
  }

  getLatestDayNaturalGasStorage(){
    return this.apiService.getEiaUrl('current_natural_gas_storage', {});
  }

  getTemperatureDepartureByClimateDivision() {
    return this.apiService.getEiaUrl('temperature_departure_by_climate_division', {});
  }

  getTemperatureDepartureFromPriorWeek() {
    return this.apiService.getEiaUrl('temperature_change_by_climate_division', {});
  }


  getTemperatureDepartureDailyAnimation() {
    return this.apiService.getEiaUrl('temperature_animation_by_climate_division', {});
  }

  getHenryHubGasPricesData() {
      return this.apiService.getEiaUrl('inventory_disposition_futures', {});
  }

  getFutureCurveImageURL() {
    return this.apiService.baseUrl + '/natural_gas_forward_curves_svg';
  }

  getArchiveReportByDate(){
    return this.apiService.getEiaUrl('archives', {} );
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/services/dashboard.service.ts